import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20with%20flowing%20ink%20wash%20texture%20in%20deep%20crimson%20and%20warm%20golden%20amber%20tones%2C%20japanese%20ukiyo-e%20inspired%20composition%20with%20soft%20gradient%20background%2C%20elegant%20negative%20space%2C%20traditional%20east%20asian%20aesthetic%20blended%20with%20modern%20minimalist%20design%2C%20luxurious%20atmospheric%20feel%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-jmtt-2026&orientation=landscape"
        alt="禁漫天堂 - 成人漫画平台官方入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          禁漫天堂
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          深受用户喜爱的成人漫画平台，提供海量优质漫画资源和沉浸式阅读体验。
          <br className="hidden md:block" />
          最新访问入口、注册教程、VIP指南一站掌握。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <Link
            to="/category/hot"
            className="px-7 py-3 rounded-md bg-primary-500 text-white text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即浏览漫画
          </Link>
          <Link
            to="/article/jmtthub-register-login-tutorial"
            className="px-7 py-3 rounded-md bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            注册教程
          </Link>
        </div>

        <div className="mt-10 md:mt-14 flex items-center gap-6 md:gap-10">
          {[
            { num: '10万+', label: '漫画资源' },
            { num: '500万+', label: '注册用户' },
            { num: '99.9%', label: '服务可用率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-xl md:text-2xl font-heading font-bold text-white">{stat.num}</p>
              <p className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}